const contacts = [
    {
        name: "Timo Matis",
        position: "Commitee Co-Chair",
        stake : "Indianapolis Indiana",
        ward: "Crossroads",
        phone: "317-937-9301",
        email: "timonmatis@gmail.com",
        photo: "./images/timo2020a.jpg",
    },
    {
        name: "Kiera B.",
        position: "Commitee Co-Chair",
        stake : "Indianapolis Indiana",
        ward: "Greenwood 2nd",
        phone: "N/A",
        email: "N/A",
    }
]

export default contacts;